import { useContext } from 'react';

import { CoursesContext, type ICoursesContextData } from '../contexts/course';

export const useCourse = (): ICoursesContextData => useContext(CoursesContext);
